'use client';

import { Accordion } from '@mantine/core';
import cn from 'classnames';
import Image from 'next/image';
import Link from 'next/link';
import { ReactMarkdown } from 'react-markdown/lib/react-markdown';

import { useUserAgent } from '@/contexts/UserAgentContext';
import plusIcon from 'public/icons/plus.svg';

import { accordionStyles } from './styles';
import styles from './styles.module.scss';
import { Props } from './types';

const ProductAccordion = ({
  descriptionLabel,
  descriptionText,
  dataName,
  dataHandle,
  dataInfo,
  isModalOpened,
}: Props) => {
  const { isMacOS, isAndroid } = useUserAgent();

  return (
    <Accordion
      chevron={
        <Image
          src={plusIcon}
          width={14}
          alt="Ikona plusa"
          className={styles.plusIcon}
        />
      }
      styles={accordionStyles}
      className={cn({
        [styles.avenirFont]: isMacOS || isAndroid,
      })}
      disableChevronRotation={isModalOpened}
    >
      <Accordion.Item
        value="customization"
        className={styles.productDescription}
      >
        <Accordion.Control>{descriptionLabel}</Accordion.Control>
        <Accordion.Panel>
          {dataName && dataHandle && (
            <Link
              href={`/vendors/${dataHandle}/`}
              className={cn(styles.name, {
                [styles.avenirFont]: isMacOS || isAndroid,
              })}
            >
              {dataName}
            </Link>
          )}
          {dataInfo ? (
            <div className={styles.contentWrapper}>
              {dataInfo.info.map(info => {
                return (
                  info.id && (
                    <div className={styles.infoWrapper} key={info.id}>
                      <div className={styles.iconWrapper}>
                        <Image
                          src={info.icon}
                          alt={info.label}
                          width={20}
                          height={20}
                        />
                      </div>
                      <p
                        className={cn(styles.label, {
                          [styles.avenirFont]: isMacOS || isAndroid,
                        })}
                      >
                        {info.label}
                      </p>
                    </div>
                  )
                );
              })}
            </div>
          ) : (
            <>
              {typeof descriptionText === 'string' ? (
                <ReactMarkdown skipHtml={false} className={styles.text}>
                  {descriptionText}
                </ReactMarkdown>
              ) : (
                descriptionText
              )}
            </>
          )}
        </Accordion.Panel>
      </Accordion.Item>
    </Accordion>
  );
};

export default ProductAccordion;
